// extracted by mini-css-extract-plugin
export var downloadBtn = "blog-post-module--downloadBtn--CjFRV";
export var sbShowMain = "blog-post-module--sb-show-main--Lq5Ub";
export var title = "blog-post-module--title--plsEI";